module.exports = __webpack_public_path__ + "static/media/pod-online.4923cfea.svg";